import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DaytranService } from 'src/providers/daytran-ervice/daytran.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { SnapShotComponent } from '../snap-shot/snap-shot.component';
@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {
  @Input() public empno;
  @Input() public type;
  @ViewChild('input') input: ElementRef;
  currentEmpNo;
  currentType;
  requestBy;
  allow_nolocation;
  constructor(
    public activeModal: NgbActiveModal,
    private daytranService: DaytranService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) { }

  async ngOnInit(): Promise<void>{
    this.currentEmpNo = this.empno;
    this.currentType = this.type;
    const syspar = await this.daytranService.photoEnabled();
    this.allow_nolocation = syspar.allow_nolocation;
  }

  ngAfterViewInit() {
    this.input.nativeElement.focus();
  }

  close() {
    this.activeModal.close();
  }

  async submit(): Promise<void> {
    if (this.requestBy === this.currentEmpNo) {
      const photoEnabled = await this.daytranService.photoEnabled();
      if (photoEnabled.success === 1) {
        const modalRef = this.modalService.open(SnapShotComponent, { size: 'md' });
        modalRef.componentInstance.empno = this.currentEmpNo;
        modalRef.componentInstance.type = this.currentType;
        modalRef.result.then(next => this.activeModal.close(), reject => this.activeModal.close());
      } else {
        this.spinner.show();
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((position) => {
            const body = {
              in_out: this.currentType,
              empcode: this.currentEmpNo,
              longitude: position.coords.longitude,
              latitude: position.coords.latitude
            };

            this.daytranService.sendDaytran(body).then(async next => {
              if (next.success === 1) {
                await this.spinner.hide();
                this.toastr.success(next.message, next.employee);
              } else {
                await this.spinner.hide();
                this.toastr.error(next.message);
              }
              this.activeModal.close();
            });
          }, failure => {
            //secured server
            //no network
            if (this.allow_nolocation == 1) {
              console.log("Failed: ",failure.message);
              if (failure.message.startsWith('Only secure origins are allowed') || failure.message.startsWith('Network location provider')) {
                const body = {
                  in_out: this.currentType,
                  empcode: this.currentEmpNo
                };

                this.daytranService.sendDaytran(body).then(async next => {
                  if (next.success === 1) {
                    await this.spinner.hide();
                    this.toastr.success(next.message, next.employee);
                  } else {
                    await this.spinner.hide();
                    this.toastr.error(next.message);
                  }
                  this.activeModal.close();
                });
              }
            } else {
              this.toastr.error("No location detected, Try again!");
            }
            
          });
        }
      }
    } else {
      await this.spinner.hide();
      this.toastr.error('Employee No\'s do not match');
      this.activeModal.close();
    }
  }
}
